import { Action, Reducer } from 'redux';
import { TemplateEmailNotificationState, TemplateEmailNotificationTypes, DomainBySystemApplicationActionTypes } from './templateEmailNotificationTypes';

export const INITIAL_STATE: TemplateEmailNotificationState = {
  domainBySystemApplication: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const templateEmailNotificationReducer: Reducer<TemplateEmailNotificationState> = (
  state: TemplateEmailNotificationState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as DomainBySystemApplicationActionTypes;
  switch (actionTypes.type) {
    case TemplateEmailNotificationTypes.GET_DOMAIN_BY_SYSTEM_APPLICATION:
      return {
        ...state,
        domainBySystemApplication: { ...state.domainBySystemApplication, isLoading: true }
      };
    case TemplateEmailNotificationTypes.SAVE_DOMAIN_BY_SYSTEM_APPLICATION:
      return {
        ...state,
        domainBySystemApplication: {
          ...state.domainBySystemApplication,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case TemplateEmailNotificationTypes.RESET_REDUCER_DOMAIN_BY_SYSTEM_APPLICATION:
      return {
        ...state,
        domainBySystemApplication: INITIAL_STATE.domainBySystemApplication
      };
    default:
      return state;
  }
};

export default templateEmailNotificationReducer;
